import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider, useApp } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Operations from "@/pages/Operations";
import OperationNew from "@/pages/OperationNew";
import OperationDetail from "@/pages/OperationDetail";
import Autorisations from "@/pages/Autorisations";
import AutorisationNew from "@/pages/AutorisationNew";
import AutorisationDetail from "@/pages/AutorisationDetail";
import Coactivite from "@/pages/Coactivite";
import Actions from "@/pages/Actions";
import Zones from "@/pages/Zones";
import Regles from "@/pages/Regles";
import Sites from "@/pages/Sites";
import Organisation from "@/pages/Organisation";
import PdpPrint from "@/pages/PdpPrint";

function Shell() {
  const { user, ready } = useAuth();
  const { loaded } = useApp();
  if (!ready) return <div style={{ padding: 40 }} className="mono">Chargement…</div>;
  if (!user) return <Login />;
  if (!loaded) return <div style={{ padding: 40 }} className="mono">Chargement du référentiel…</div>;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/operations" element={<Operations />} />
        <Route path="/operations/new" element={<OperationNew />} />
        <Route path="/operations/:id" element={<OperationDetail />} />
        <Route path="/autorisations" element={<Autorisations />} />
        <Route path="/autorisations/new" element={<AutorisationNew />} />
        <Route path="/autorisations/:id" element={<AutorisationDetail />} />
        <Route path="/coactivite" element={<Coactivite />} />
        <Route path="/actions" element={<Actions />} />
        <Route path="/zones" element={<Zones />} />
        <Route path="/sites" element={<Sites />} />
        <Route path="/organisation" element={<Organisation />} />
        <Route path="/regles" element={<Regles />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

function Gate() {
  const { user, ready } = useAuth();
  if (!ready) return <div style={{ padding: 40 }} className="mono">Chargement…</div>;
  if (!user) return <Login />;
  return <PdpPrint />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/pdp/:oid/print" element={<Gate />} />
            <Route path="/*" element={<Shell />} />
          </Routes>
        </AppProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
